import { Directive, inject, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AppContext } from '../../app.context';
import { Permission } from '../permissions';

@Directive({
  selector: '[rolePermission]',
  standalone: true,
})
export class RolePermissionDirective implements OnInit {
  private templateRef = inject(TemplateRef<unknown>);
  private viewContainerRef = inject(ViewContainerRef);
  private appContext = inject(AppContext);

  @Input({ required: true }) rolePermission!: Permission;

  ngOnInit(): void {
    if (this.appContext.hasPermission(this.rolePermission)) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }
}
